import React, { useState } from 'react'
import { Checkbox, Empty, Select, Space, Tag, Typography } from 'antd'
import { scopeSelection, updateScope } from './policySelection'
import PolicyMenuTree from './PolicyMenuTree'
import HelpHint from './HelpHint'
import { POLICY_MODES, scopeEffect } from './policyDisplay'

// 2026-10-27 coder(lq): 系统来自真实根菜单；勾选系统默认先观察，不自动打开总开关或更改其他系统。
export default function PolicySystems({ scopes, policy, onChange, onError }) {
    const [activeKey, setActiveKey] = useState(null)
    const scope = scopes.find(item => item.key === activeKey) || scopes[0]
    const selection = scope ? scopeSelection(scope, policy) : { keys: [], mode: 'OFF' }
    const effect = scopeEffect(policy, selection)
    const update = (item, value) => {
        try { onChange(updateScope(policy, item, value)) } catch (error) { onError(error.message) }
    }
    if (!scope) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="未读取到系统菜单，请检查菜单数据源后刷新；不会自动创建系统或导入关系。" />
    return <div className="menu-api-policy-layout">
        <aside className="menu-api-policy-system-list" aria-label="系统开关列表">
            <div className="menu-api-policy-list-heading"><strong>系统</strong><HelpHint label="系统开关说明">
                勾选系统默认使用“仅观察”，不阻断请求；可在右侧改为正式拦截。关闭系统会停用其当前菜单范围。
                系统和菜单来自当前环境，不使用导入清单的菜单ID；同一服务下的售后和SCRM分别显示。</HelpHint></div>
            {scopes.map(item => {
                const draft = scopeSelection(item, policy)
                return <div key={item.key} className={`menu-api-policy-system${item.key === scope.key ? ' is-active' : ''}`}>
                    <Checkbox aria-label={`启用${item.title}`} checked={draft.mode !== 'OFF'} disabled={item.incomplete || !item.keys.length}
                        onChange={event => update(item, { keys: draft.keys.length ? draft.keys : item.keys,
                            mode: event.target.checked ? 'AUDIT' : 'OFF' })} />
                    <button type="button" aria-pressed={item.key === scope.key} onClick={() => setActiveKey(item.key)}>
                        <strong>{item.title}</strong><span>{item.incomplete ? `层级异常 · ${item.keys.length} 个菜单 · 只读` : `${POLICY_MODES[draft.mode]} · 已选 ${draft.keys.length} 个菜单`}</span>
                    </button>
                </div>
            })}
        </aside>
        <section className="menu-api-policy-scope" aria-label="系统菜单配置">
            <div className="menu-api-scope-heading"><div className="menu-api-scope-summary"><Typography.Title level={3}>{scope.title}</Typography.Title>
                <Typography.Text className="menu-api-scope-count" type="secondary">{scope.keys.length} 个菜单 · {scope.count} 条接口关系</Typography.Text></div>
                <div className="menu-api-policy-mode-control"><span>本系统运行方式</span><Select aria-label={`${scope.title}本系统运行方式`} className="menu-api-policy-mode"
                    value={selection.mode} disabled={scope.incomplete || !scope.keys.length}
                    options={Object.entries(POLICY_MODES).map(([value, label]) => ({ value, label, disabled: value === 'MIXED' }))}
                    onChange={mode => update(scope, { mode, keys: selection.keys.length ? selection.keys : scope.keys })} /></div></div>
            {scope.incomplete ? <Typography.Text type="danger">这些菜单的父级存在循环或缺失，已隔离为只读；其他系统可正常配置，已有策略不会自动删除。</Typography.Text>
                : selection.mode === 'MIXED' ? <Typography.Text type="warning">原配置中各菜单运行方式不同；请先选择统一方式，再调整菜单范围。</Typography.Text> : null}
            <Space className="menu-api-policy-scope-state"><Tag role="status" aria-label="本系统保存后效果">保存后：{effect.label}</Tag>
                <HelpHint label="系统生效范围说明">{effect.reason}这里展示的是待保存策略，不代表网关实际运行状态已验证。未映射接口仍不新增拦截；共享接口仍按原有多菜单及正式拦截范围规则判断，不因单个系统关闭或观察而保证放行。
                    已有服务级规则原样保留；本页对已读取菜单使用精确覆盖，未知菜单不会被静默删除。</HelpHint></Space>
            <PolicyMenuTree key={scope.key} scope={scope} selection={selection}
                disabled={scope.incomplete || selection.mode === 'MIXED'}
                onChange={keys => update(scope, { keys, mode: keys.length ? selection.mode : 'OFF' })} />
        </section>
    </div>
}
